/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetUserIdRiotAccountsQueryResponse,
  GetUserIdRiotAccountsPathParams,
  GetUserIdRiotAccounts500,
} from "../types/GetUserIdRiotAccounts.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getUserIdRiotAccountsQueryKey = (
  id: GetUserIdRiotAccountsPathParams["id"] | undefined,
) => [{ url: "/user/:id/riot-accounts", params: { id: id } }] as const;

export type GetUserIdRiotAccountsQueryKey = ReturnType<
  typeof getUserIdRiotAccountsQueryKey
>;

/**
 * @description Возвращает все привязанные League of Legends аккаунты пользователя.
 * @summary Получение Riot аккаунтов пользователя
 * {@link /user/:id/riot-accounts}
 */
export async function getUserIdRiotAccounts(
  id: GetUserIdRiotAccountsPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetUserIdRiotAccountsQueryResponse,
    ResponseErrorConfig<GetUserIdRiotAccounts500>,
    unknown
  >({ method: "GET", url: `/user/${id}/riot-accounts`, ...requestConfig });
  return res;
}

export function getUserIdRiotAccountsQueryOptions(
  id: GetUserIdRiotAccountsPathParams["id"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getUserIdRiotAccountsQueryKey(id);
  return queryOptions<
    ResponseConfig<GetUserIdRiotAccountsQueryResponse>,
    ResponseErrorConfig<GetUserIdRiotAccounts500>,
    ResponseConfig<GetUserIdRiotAccountsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getUserIdRiotAccounts(id!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Возвращает все привязанные League of Legends аккаунты пользователя.
 * @summary Получение Riot аккаунтов пользователя
 * {@link /user/:id/riot-accounts}
 */
export function useGetUserIdRiotAccounts<
  TData = ResponseConfig<GetUserIdRiotAccountsQueryResponse>,
  TQueryData = ResponseConfig<GetUserIdRiotAccountsQueryResponse>,
  TQueryKey extends QueryKey = GetUserIdRiotAccountsQueryKey,
>(
  id: GetUserIdRiotAccountsPathParams["id"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetUserIdRiotAccountsQueryResponse>,
        ResponseErrorConfig<GetUserIdRiotAccounts500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getUserIdRiotAccountsQueryKey(id);

  const query = useQuery(
    {
      ...getUserIdRiotAccountsQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetUserIdRiotAccounts500>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
